"use strict";
//import {FindReact} from "react-vextensions";
//import {Vector2i} from "js-vextensions";
HTMLElement.prototype._AddGetter_Inline = function R() { return g.FindReact(this); };
Element.prototype._AddFunction_Inline = function GetPageRect() {
    var box = this.getBoundingClientRect();
    const win = this.ownerDocument.defaultView;
    return new g.VRect(
    /*box.left + (window.pageXOffset || document.documentElement.scrollLeft) - (document.documentElement.clientLeft || 0),
    box.top + (window.pageYOffset || document.documentElement.scrollTop) - (document.documentElement.clientTop  || 0),*/
    box.left + win.pageXOffset, box.top + win.pageYOffset, box.width, box.height);
};
// Object
// ==========
function WaitTillDataPathIsSet(dataPath) {
    return new Promise(async (resolve, reject) => {
        const dataPathParts = dataPath.split(".");
        let currentParent = g;
        for (const part of dataPathParts) {
            while (currentParent[part] == null) {
                await WaitTillPropertyIsSet(currentParent, part);
            }
            currentParent = currentParent[part];
        }
        resolve();
    });
}
function WaitTillPropertyIsSet(obj, prop) {
    return new Promise((resolve, reject) => {
        obj._AddGetterSetter(prop, () => { }, value => {
            delete obj[prop]; // remove this hook
            obj[prop] = value; // set to provided value
            resolve();
        });
    });
}
// fix for that "store" is not passed as context/props to Connect component, for threejs components
//interface Object { store: any; }
/*Object.prototype._AddGetter_Inline = function store() {
    return store;
};*/
/*Object.prototype._AddGetterSetter("store", ()=> {
    return store;
}, ()=>{});*/
//Object.defineProperty(Object.prototype, "store", {value: store});
// note: helps for threejs, but breaks react-beautiful-dnd
/*(async ()=> {
    await WaitTillDataPathIsSet("React.Component");
    React.Component.prototype._AddGetterSetter("store", ()=>store, ()=>{});
})();*/ 
